import { Link } from 'react-router-dom';
import { Button } from '../components/ui/Button';
import { EmptyState } from '../components/ui/EmptyState';

export function NotFoundPage() {
  return (
    <EmptyState
      title="Seite nicht gefunden"
      description="Diese Seite existiert nicht (mehr)."
      action={
        <Link to="/">
          <Button variant="secondary">Zur Startseite</Button>
        </Link>
      }
    />
  );
}
